export const feedbackSespelUrl = 'https://feedback.sespel.su';
